<div class="grid-container padding-y-4">
  <div class="grid-row">
    <legend class="usa-legend usa-legend--large">FAIC List</legend>
  </div>
  <div class="grid-row margin-top-2">
    <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon">
    Right click on the report and select the appropriate options to export.
  </div>
  <div class="margin-top-2">
    <ag-grid-angular class="ag-theme-alpine"
                     style="height: 400px;"
                     [rowData]="faicListDetails"
                     [domLayout]="domLayout"
                     [pagination]="true"
                     [excelStyles]="excelStyles"
                     [paginationPageSize]="paginationPageSize"
                     [columnDefs]="faicListColumnDefs">
    </ag-grid-angular>
  </div>
</div>

